import * as actionTypes from '@store/filter/action-types';

const initialState = {
	selectedFilterItems: [],
	roleList: [],
	userTypeList: [],
	statusList: [],
	projectManagerList: [],
	accountManagerList: [],
	designStageList: [],
	seasonList: [],
	fabricTypeList: [],
	materialCompositionList: [],
	myCollectionList: [],
	collectionPrivacyList: [],
	productGroupList: [],
	brandList: [],
	orderStatusList: [],
	taskMemberList: [],
	taskStageNamesList: [],
	taskOrderProductList: [],
	taskOrderList: [],
	taskBrandList: [],
	taskStatusList: [],
	collectionOwnerList: [],
	quoteStatusList: [],
	invoiceStatusList: [],
	isNitexProductOptions: [
		{ key: true, value: 'Yes', _key: 'Y' },
		{ key: false, value: 'No', _key: 'N' }
	],
	showFilter: true,
	SCOPE: {
		NAME: {
			valName: 'name',
			type: 'text',
			title: 'Name',
			paramName: 'name'
		},
		CLIENT_NAME: {
			valName: 'clientName',
			type: 'text',
			title: 'Client name',
			paramName: 'name'
		},
		ORDER_CLIENT_NAME: {
			valName: 'orderClientName',
			type: 'text',
			title: 'Client name',
			paramName: 'clientName'
		},
		ORDER_NAME: {
			valName: 'orderName',
			type: 'text',
			title: 'Order name',
			paramName: 'orderName'
		},
		COMPANY_NAME: {
			valName: 'companyName',
			type: 'text',
			title: 'Company name',
			paramName: 'companyName'
		},
		EMAIL: {
			valName: 'email',
			type: 'text',
			title: 'Email',
			paramName: 'email'
		},
		COLLECTION_NAME: {
			valName: 'collectionName',
			type: 'text',
			title: 'Collection name',
			paramName: 'name'
		},
		DESIGN_NAME: {
			valName: 'name',
			type: 'text',
			title: 'Design name',
			paramName: 'search'
		},
		DESIGN_REFERENCE_NUMBER: {
			valName: 'referenceNumber',
			type: 'text',
			title: 'Design number',
			paramName: 'referenceNumber'
		},
		DESIGN_IS_NITEX_PRODUCT: {
			valName: 'isNitexProductOptions',
			type: 'select',
			title: 'Is Nitex product',
			paramName: 'isNitexProduct',
			valueIdentifier: 'key',
			labelIdentifier: 'value'
		},
		DESIGN_COLLECTION_TITLE: {
			valName: 'designCollectionTitle',
			type: 'text',
			title: 'Design/Collection title',
			paramName: 'search'
		},
		INVOICE_NUM: {
			valName: 'name',
			type: 'text',
			title: 'Invoice number',
			paramName: 'search'
		},
		ROLE_LIST: {
			valName: 'roleList',
			type: 'select',
			title: 'Roles',
			paramName: 'userLevelId',
			valueIdentifier: 'id',
			labelIdentifier: 'name'
		},
		USER_TYPE_LIST: {
			valName: 'userTypeList',
			type: 'select',
			title: 'User Types',
			paramName: 'userType',
			valueIdentifier: 'value',
			labelIdentifier: 'label'
		},
		STATUS_LIST: {
			valName: 'statusList',
			type: 'select',
			title: 'Status',
			paramName: 'status',
			valueIdentifier: 'key',
			labelIdentifier: 'value'
		},
		PROJECT_MANAGER_LIST: {
			valName: 'projectManagerList',
			type: 'select',
			title: 'Project manager',
			paramName: 'managerId',
			valueIdentifier: 'id',
			labelIdentifier: 'name'
		},
		PROJECT_MANAGER_ID_LIST: {
			valName: 'projectManagerList',
			type: 'select',
			title: 'Project manager',
			paramName: 'projectManagerIdList',
			valueIdentifier: 'id',
			labelIdentifier: 'name'
		},
		ACCOUNT_MANAGER_LIST: {
			valName: 'accountManagerList',
			type: 'select',
			title: 'Account manager',
			paramName: 'executiveId',
			valueIdentifier: 'id',
			labelIdentifier: 'name'
		},
		ACCOUNT_MANAGER_ID_LIST: {
			valName: 'accountManagerList',
			type: 'select',
			title: 'Account manager',
			paramName: 'accountManagerIdList',
			valueIdentifier: 'id',
			labelIdentifier: 'name'
		},
		DATE_PICKER: {
			valName: 'datePicker',
			type: 'date',
			title: 'Date',
			paramName: 'date',
			value: ''
		},
		DATE_RANGE_PICKER: {
			valName: 'dateRangePicker',
			type: 'dateRange',
			title: 'Date',
			paramName1: 'fromDate',
			paramName2: 'toDate',
			value1: '',
			value2: ''
		},
		COLLECTION_PRIVACY: {
			valName: 'collectionPrivacyList',
			type: 'select',
			title: 'Privacy',
			paramName: 'privacy',
			valueIdentifier: 'value',
			labelIdentifier: 'label'
		},
		PRODUCT_GROUP_LIST: {
			valName: 'productGroupList',
			type: 'select',
			title: 'Product group',
			paramName: 'productGroupId',
			valueIdentifier: 'id',
			labelIdentifier: 'name'
		},
		DESIGN_STAGE_LIST: {
			valName: 'designStageList',
			type: 'select',
			title: 'Stage',
			paramName: 'availabilityStatus',
			valueIdentifier: 'value',
			labelIdentifier: 'label'
		},
		SEASON_LIST: {
			valName: 'seasonList',
			type: 'select',
			title: 'Season',
			paramName: 'season',
			valueIdentifier: 'value',
			labelIdentifier: 'label'
		},
		FABRIC_TYPE_LIST: {
			valName: 'fabricTypeList',
			type: 'select',
			title: 'Fabric type',
			paramName: 'fabricType',
			valueIdentifier: 'value',
			labelIdentifier: 'label'
		},
		MATERIAL_COMPOSITION_LIST: {
			valName: 'materialCompositionList',
			type: 'select',
			title: 'Material composition',
			paramName: 'materialComposition',
			valueIdentifier: 'value',
			labelIdentifier: 'label'
		},
		MY_COLLECTION_LIST: {
			valName: 'myCollectionList',
			type: 'select',
			title: 'Collections',
			paramName: 'collection',
			valueIdentifier: 'id',
			labelIdentifier: 'name'
		},
		BRAND_LIST: {
			valName: 'brandList',
			type: 'select',
			title: 'Brands',
			paramName: 'brandId',
			valueIdentifier: 'id',
			labelIdentifier: 'name'
		},
		BRAND_ID_LIST: {
			valName: 'brandList',
			type: 'select',
			title: 'Brands',
			paramName: 'brandIdList',
			valueIdentifier: 'id',
			labelIdentifier: 'name'
		},
		ORDER_STATUS_LIST: {
			valName: 'orderStatusList',
			type: 'select',
			title: 'Status',
			paramName: 'status',
			valueIdentifier: 'value',
			labelIdentifier: 'label'
		},
		TASK_MEMBER_LIST: {
			valName: 'taskMemberList',
			type: 'select',
			title: 'Persons',
			paramName: 'memberIds',
			valueIdentifier: 'value',
			labelIdentifier: 'label'
		},
		TASK_STAGE_NAMES_LIST: {
			valName: 'taskStageNamesList',
			type: 'select',
			title: 'Stage',
			paramName: 'stageNames',
			valueIdentifier: 'value',
			labelIdentifier: 'label'
		},
		TASK_ORDER_PRODUCT_LIST: {
			valName: 'taskOrderProductList',
			type: 'select',
			title: 'Style',
			paramName: 'styleIds',
			valueIdentifier: 'value',
			labelIdentifier: 'label'
		},
		TASK_ORDER_LIST: {
			valName: 'taskOrderList',
			type: 'select',
			title: 'Order',
			paramName: 'orderIds',
			valueIdentifier: 'value',
			labelIdentifier: 'label'
		},
		TASK_BRAND_LIST: {
			valName: 'taskBrandList',
			type: 'select',
			title: 'Brand',
			paramName: 'brandIds',
			valueIdentifier: 'value',
			labelIdentifier: 'label'
		},
		TASK_STATUS_LIST: {
			valName: 'taskStatusList',
			type: 'select',
			title: 'Status',
			paramName: 'taskStatus',
			valueIdentifier: 'value',
			labelIdentifier: 'label'
		},
		COLLECTION_OWNER_LIST: {
			valName: 'collectionOwnerList',
			type: 'text',
			title: 'Owner',
			paramName: 'ownerEmail'
		},
		QUOTES_STATUS_LIST: {
			valName: 'quoteStatusList',
			type: 'select',
			title: 'Status',
			paramName: 'status',
			valueIdentifier: 'value',
			labelIdentifier: 'label'
		},
		INVOICE_STATUS_LIST: {
			valName: 'invoiceStatusList',
			type: 'select',
			title: 'Status',
			paramName: 'status',
			valueIdentifier: 'value',
			labelIdentifier: 'label'
		},
		PO_NUMBER: {
			valName: 'poNumber',
			type: 'text',
			title: 'Po number',
			paramName: 'poNumber'
		}
	},
	showItemsCount: { isShowItemsCount: true }
};

export default (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.FETCH_FILTER_DATA: {
			return {
				...state,
				[action.payload.key]: action.payload.data
			};
		}
		case actionTypes.TOGGLE_FILTER_ITEM: {
			let flag = false;
			let items = [...state.selectedFilterItems];
			items = items.filter((item) => {
				if (item.name === action.payload.name && item.value === action.payload.value) {
					flag = true;
					return false;
				}
				return true;
			});
			if (!flag) {
				items.push(action.payload);
			}
			return {
				...state,
				selectedFilterItems: items
			};
		}
		case actionTypes.CREATE_OR_UPDATE_FILTER_ITEM: {
			let flag = false;
			let items = [...state.selectedFilterItems];
			items = items.map((item) => {
				if (item.paramName === action.payload.paramName && item.type === action.payload.type) {
					flag = true;
					return action.payload;
				}
				return item;
			});
			if (!flag) {
				items.push(action.payload);
			}
			return {
				...state,
				selectedFilterItems: items
			};
		}
		case actionTypes.TOGGLE_SHOW_FILTER: {
			return {
				...state,
				showFilter: !state.showFilter
			};
		}
		case actionTypes.CLEAR_ALL_FILTERS: {
			return {
				...state,
				selectedFilterItems: []
			};
		}
		case actionTypes.GET_ALL_FILTERS: {
			return {
				...state
			};
		}
		case actionTypes.IS_SHOW_ITEMS_COUNT: {
			return {
				...state,
				showItemsCount: { isShowItemsCount: action.payload }
			};
		}
		default:
			return state;
	}
};
